<template>
    <div>
        <!-- <div class="standard" @click="$refs.rules.showDrawer()">
            评价指标
        </div> -->
        <div class="info-box">
            <div class="info-title">
                <h3>课堂教学质量信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box">
                    <p>任务来源：</p>
                    <a-select 
                        class="input" 
                        allowClear 
                        v-model="info.taskSource" 
                        :disabled="type=='look'" 
                        :filter-option="filterOption">
                        <a-select-option v-for="(item,index) in rwlyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>课程名称：</p>
                    <a-input class="input" v-model="info.courseName" disabled />
                </div>
                <div class="input-box">
                    <p>课程编号：</p>
                    <a-input class="input" v-model="info.courseId" disabled />
                </div>
                <div class="input-box">
                    <p>授课教师：</p>
                    <a-select 
                        class="input" 
                        allowClear
                        show-search
                        :filter-option="filterOption"
                        v-model="info.teacherName"
                        @change="teacherChange"
                        option-label-prop="label"
                        disabled>
                        <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherName" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>授课教师编号：</p>
                    <a-input class="input" v-model="info.teacherId" disabled />
                </div>
                <div class="input-box">
                    <p>开课学院/系：</p>
                    <a-input class="input" v-model="info.orgName" disabled />
                </div>
                <div class="input-box">
                    <p><span>*</span>讲课章节：</p>
                    <a-input class="input" v-model="info.courseChapter" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>授课时间：</p>
                    <a-input class="input" v-model="info.classTime" disabled />
                </div>
                <div class="input-box">
                    <p>听课教室：</p>
                    <a-input class="input" v-model="info.classRoom" disabled />
                </div>
                <div class="input-box">
                    <p>应到学生数：</p>
                    <a-input class="input" v-model="info.studentNumber" disabled />
                </div>
                <div class="input-box">
                    <p><span>*</span>实到学生数：</p>
                    <a-input class="input" v-model="info.actualAttend" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p><span>*</span>双语教学：</p>
                    <a-select 
                        :disabled="type=='look'"
                        class="input" 
                        allowClear
                        show-search
                        @change="getLanguageName"
                        :filter-option="filterOption"
                        v-model="info.bilingualType"
                        option-label-prop="label">
                        <a-select-option v-for="(item,index) in bilingualArray" :key="index" :value="item" :label="item">{{item}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>使用教材名称：</p>
                    <a-input class="input" v-model="info.textbookName" disabled />
                    <!-- <a-select 
                        class="input" 
                        allowClear
                        show-search
                        :filter-option="filterOption"
                        v-model="info.textbookName"
                        @change="jcChange"
                        :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in jcInfo" :key="index" :value="item.name">{{item.name}}</a-select-option>
                    </a-select> -->
                </div>
                <div class="input-box">
                    <p>版本：</p>
                    <a-input class="input" v-model="info.textbookEdition" disabled />
                </div>
                <div class="input-box">
                    <p>出版年月：</p>
                    <a-input class="input" v-model="info.textbookPublishDate" disabled />
                </div>
                <div class="input-box">
                    <p>是否国家级规划教材：</p>
                    <a-select class="input" v-model="info.textbookIsStateLevel" disabled>
                        <a-select-option :value="true" >是</a-select-option>
                        <a-select-option :value="false" >否</a-select-option>
                    </a-select>
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>评价指标及内涵</h3>
                <p></p>
            </div>
            <div class="info-main">
                <a-list item-layout="horizontal" :data-source="rules" class="list">
                    <a-list-item slot="renderItem" slot-scope="item">
                        <a-list-item-meta
                            :description="item.text"
                        >
                            <p slot="title">{{ item.title }}</p>
                        </a-list-item-meta>
                    </a-list-item>
                </a-list>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>课堂评价信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box">
                    <p><span>*</span>评分：</p>
                    <a-input class="input" v-model="info.checkScore" :disabled="type=='look'" @change="getCheckLevel"/>
                </div>
                <div class="input-box">
                    <p>等级：</p>
                    <!-- <a-select 
                        class="input" 
                        allowClear 
                        v-model="info.checkLevel" 
                        :disabled="type=='look'" 
                        :filter-option="filterOption">
                        <a-select-option v-for="(item,index) in kpdjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select> -->
                    <a-input class="input" v-model="info.checkLevel" disabled />

                </div>
                <div class="input-box" v-if="sysRoles.indexOf('ROLE_UNDERGRADUATE_ASSISTANT') > -1 ||sysRoles.indexOf('SUPERADMIN') > -1">
                    <p><span>*</span>听课教师：</p>
                    <a-select
                        mode="tags"
                        class="input" 
                        allowClear
                        show-search
                        :filter-option="filterOption"
                        v-model="info.judgeTeacherName"
                        @change="teacherChange1"
                        option-label-prop="label"
                        :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherName" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box" v-if="sysRoles.indexOf('ROLE_UNDERGRADUATE_ASSISTANT') > -1||sysRoles.indexOf('SUPERADMIN') > -1">
                    <p>听课教师编号：</p>
                    <a-input class="input" v-model="info.judgeTeacherId"  :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p><span>*</span>听课时间：</p>
                    <a-date-picker class="input" v-model="info.judgeDate" @change="(date, dateString)=>{info.judgeDate=dateString}" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p><span>*</span>节数：</p>
                    <a-input class="input" v-model="info.judgeLesson" :disabled="type=='look'" />
                </div>
                <div class="input-maxbox">
                    <p><span style="color: #ff0000;">*</span>教学过程综合评价：</p>
                    <a-textarea
                        class="textarea"
                        v-model="info.courseComment"
                        :auto-size="{ minRows: 3, maxRows: 5 }"
                        :disabled="type=='look'"
                        />
                </div>
                <div class="input-notes">
                    <div class="note-title">注：</div>
                    <div class="notes">1. 综合评价中的等级：A：95-100  A-：90-94  B+：85-89  B：80-84  B-：75-79  C+：70-74  C：60-69  D：&lt;60；<br>
                    2.“任务来源”包括：（1）常规听课；（2）晋升职称听课；（3）教学竞赛听课；（4）专业认证听课；（5）其他专项</div>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <a-popconfirm
                    title="确定提交？提交后只有本科教学专员才能修改或删除！"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="sub"
                >
                <a-button type="primary" v-if="type!='look'">提交</a-button>
            </a-popconfirm>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
        <rules ref="rules"></rules>
    </div>
</template>
<script>
    import moment from 'moment'
    import { getDicts } from '@/baseAPI/dictionary'
    import { info } from '@/baseAPI/undergraduate/culture/course'
    import { add,update,classroomInfo,books } from '@/baseAPI/undergraduate/culture/classroom'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    // import { bookInfo } from '@/baseAPI/undergraduate/culture/syllabusAndBooks'
    export default {
        name: 'teacher',
        data () {
            return {
                type:'',
                info:{
                    taskSource:null,
                    courseInfoId:null,
                    courseChapter:null,
                    actualAttend:null,
                    bilingualType:null,
                    textbookId:null,
                    checkScore:null,
                    checkLevel:null,
                    courseComment:null,
                    judgeTeacherId:null,
                    judgeTeacherName:null,
                    judgeDate:null,
                    judgeLesson:null,
                    textbookName:null,
                    semester:null
                },
                languageName:'',
                semester:'',
                rwlyArr:[],
                kpdjArr:[],
                jsArr:[],
                kcArr:[],
                jcInfo:{},
                sysRoles:[],
                bilingualArray:['否','外语讲课、外语板书、使用外语教材','中文讲课、中文板书、使用外语教材'],
                rules:[
                        {
                            title: '教学理念',
                            text:'坚持立德树人要求，教学观点正确，突出课堂德育；治学严谨，言论健康，风格突出，感染力强；符合“学生中心、产出导向和持续改进”的教育教学理念。'
                        },
                        {
                            title: '教学内容',
                            text:'贯彻教学大纲，教学内容充实、渗透专业思想；注重研究型挑战性教学设计，反映学科新思想、新概念、新成果；教学载体能有效支撑课程目标。'
                        },
                        {
                            title: '授课方式',
                            text:'重点突出，条理清晰，内容承前启后，循序渐进；讲解熟练，有深度、有广度；注重师生互动和启发思维教学模式，重视培养学生分析和解决问题能力。'
                        },
                        {
                            title: '教学手段',
                            text:'教学过程安排合理，方法运用灵活、恰当；启发性强，能有效调动学生思维和学习积极性；熟练、有效地运用现代信息技术；板书工整、结构合理。'
                        },
                        {
                            title: '课堂氛围',
                            text:'课内互动自然、实施方式多样化，教师关注学生学习成果、课堂应变能力强；讲课有激情、能吸引学生注意力，学生深度参与课堂互动、课堂气氛融洽。'
                        },
                        {
                            title: '形象举止',
                            text:'教态仪表自然得体，精神饱满，亲和力强；语言清晰、流畅、准确、生动，语速节奏恰当；为人师表，严于律己，不迟到早退。'
                        },
                        {
                            title: '过程管理',
                            text:'课前准备充分，课前、课后有指导；对学生的自主学习提供必要的支持和指导，全面训练学生知识、能力与素质；规范学生出勤，课堂教学秩序管理严格。'
                        },
                        {
                            title: '教学效果',
                            text:'课堂讲授富有吸引力，教学进度安排合理；关注学生创新能力培养，有效激发学生学习兴趣；教学模式新颖，有利于课程目标达成，教学效果好。'
                        }
                    ]
            }
        },
        mounted () {
            this.$store.state.user.sysRoles.forEach(element => {
                this.sysRoles.push(element.code)
            });
            getDicts({dataCode:'KTJXZL_RWLY',status:true}).then(res=>{
                this.rwlyArr=res.data.dicts;
                this.info.taskSource=res.data.defaultValue[0];
            })
            // getDicts({dataCode:'KPDJ',status:true}).then(res=>{
            //     this.kpdjArr=res.data.dicts;
            //     this.info.checkLevel=res.data.defaultValue[0];
            // })
            this.type=this.$route.query.type;
            this.info.semester=this.$route.query.semester;
            getTeacher().then(res=>{
                this.jsArr=res.data;
                this.info.judgeTeacherName=this.$store.state.user.name;
                this.info.judgeTeacherId=this.$store.state.user.userId;
                this.teacherChange1(this.info.judgeTeacherName)
                if(this.type=='add'){
                    info(this.$route.query.courseId).then(res=>{
                        this.info.courseInfoId=this.$route.query.courseId;
                        this.info.courseName=res.data.courseName;
                        this.info.courseId=res.data.courseId;
                        this.info.classTime=res.data.classTime;
                        this.info.classRoom=res.data.classRoom;
                        this.info.teacherName=res.data.teacherName;
                        this.info.teacherId=res.data.teacherId;
                        this.info.orgName=res.data.orgName;
                        this.info.orgCode=res.data.orgCode;
                        this.info.studentNumber=res.data.studentNumber;
                        this.getJc();
                    })
                }else{
                    classroomInfo(this.$route.query.id).then(res=>{
                            this.info=res.data;
                            // bookInfo(this.info.textbookId).then(res=>{
                            //     this.info.textbookName=res.data.name
                            //     this.info.textbookId=res.data.id;
                            //     this.info.textbookEdition=res.data.edition;
                            //     this.info.textbookPublishDate=res.data.publishDate;
                            //     this.info.textbookIsStateLevel=res.data.isStateLevel;
                            // })
                            this.getLanguageName(this.info.bilingualType)
                        })
                    // setTimeout(()=>{
                        
                    // },500)
                }
            })
            

        },
        methods:{
            moment,
            onChange(time, timeString) {
                console.log(time, timeString);
            },
            getLanguageName(bilingualType){
                if(bilingualType.indexOf('外语教材') > -1){
                    this.languageName="英文"
                }else if(bilingualType == "否"){
                    this.languageName="中文"
                }
                this.getJc()
            },
            getCheckLevel(){
                
                if(this.info.checkScore >= 95 && this.info.checkScore <= 100){
                    this.info.checkLevel='A'
                }else if(this.info.checkScore >= 90 && this.info.checkScore <= 94){
                    this.info.checkLevel='A-'
                }else if(this.info.checkScore >= 85 && this.info.checkScore <= 89){
                    this.info.checkLevel='B+'
                }else if(this.info.checkScore >= 80 && this.info.checkScore <= 84){
                    this.info.checkLevel='B'
                }else if(this.info.checkScore >= 75 && this.info.checkScore <= 79){
                    this.info.checkLevel='B-'
                }else if(this.info.checkScore >= 70 && this.info.checkScore <= 74){
                    this.info.checkLevel='C+'
                }else if(this.info.checkScore >= 60 && this.info.checkScore <= 69){
                    this.info.checkLevel='C'
                }else if(this.info.checkScore < 60){
                    this.info.checkLevel='D'
                }                
            },
            getJc(){
                books({"courseNo":this.info.courseId,"languageName":this.languageName,"semester":this.info.semester}).then(res=>{
                    this.jcInfo=res.data;
                    this.info.textbookName=this.jcInfo.name
                    this.info.textbookId=this.jcInfo.id;
                    this.info.textbookEdition=this.jcInfo.edition;
                    this.info.textbookPublishDate=this.jcInfo.publishDate;
                    this.info.textbookIsStateLevel=this.jcInfo.isStateLevel;
                    
                })
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                var arr=['courseChapter','studentNumber','bilingualType','checkScore','courseComment','judgeDate','judgeLesson']
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        break;
                    }
                }
                if(isSub){
                    if(this.info.judgeTeacherName !=null && this.info.judgeTeacherName.constructor==Array && this.info.judgeTeacherName.length >= 1){
                        this.info.judgeTeacherName = this.info.judgeTeacherName[0]
                    }
                    if(this.info.judgeTeacherId !=null && this.info.judgeTeacherId.constructor==Array && this.info.judgeTeacherId.length >= 1){
                        this.info.judgeTeacherId = this.info.judgeTeacherId[0]
                    }
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增课堂教学质量成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改课堂教学质量成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            teacherChange(value){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherName==value){
                        this.info.teacherId=this.jsArr[i].teacherId;
                        this.info.orgCode=this.jsArr[i].orgCode;
                        this.info.orgName=this.jsArr[i].orgName;
                    }
                }
            },
            teacherChange1(value){
                this.info.judgeTeacherId=""
                if(value.constructor==Array){
                    value = value[0]
                }
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherName==value){
                        this.info.judgeTeacherId=this.jsArr[i].teacherId;
                    }
                }
                if(this.info.judgeTeacherName == null || this.info.judgeTeacherName==''){
                    this.info.judgeTeacherName = value
                }
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }

    .info-main .list{
        width: 99%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
        margin-left: 10rem;
    }
    .info-main .input-box-center{
        width: 66%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box p span{
        color: #ff0000;
        margin-right: 5px;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .input >>> .ant-input[disabled],
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .standard{
        width: 1.4rem;
        height: 6.2rem;
        position: absolute;
        right: 0;
        top: 200px;
        text-align: center;
        border-radius: 6px 0 0 6px !important;
        z-index: 0;
        pointer-events: auto;
        cursor: pointer;
        color: rgb(255, 255, 255);
        background-color: #245086;
        opacity: 0.8;
        padding: 2px 0px 0px 0px;
    }

    .standard:hover{
        opacity: 1;
    }

    .info-main .input-maxbox{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-maxbox p{
        width: 10rem;
        text-align: right;
    }

    .info-main .input-maxbox .textarea{
        width: calc(100% - 10rem);
    }

    .info-main .input-notes{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-notes .notes{
        width: calc(100% - 10rem);
        text-align: left;
        font-size: 0.9rem;
    }

    .info-main .input-notes .note-title{
        width: 10rem;
        text-align: right;
        font-size: 0.9rem;
        font-weight: bolder;
        color: black;
    }

    .ant-list-item-meta {
        display: flex;
        flex: 1;
        align-items: flex-start;
        font-size: 1rem;
    }

</style>
